// Module
var code = "<footer ng-if=\"vm.year && vm.barnManagerVersion\" role=\"contentinfo\" class=\"app-footer\"> <div class=\"content-area app-footer__content-area\"> <p> &copy; {{ vm.year }} BarnManager <br>(Version {{ vm.barnManagerVersion }}) </p> </div> </footer> ";
// Exports
module.exports = code;